<template>
  <main class="mt-5" id="page-refund">
    <div class="card mt-3">
      <div class="card-header  border-0">
        <h5 class="card-title font-bold py-3">گزارش مشتریان</h5>
        <div style="flex: 1"></div>
        <ExcelDownload class="mr-3" :url="excelUrl" />
      </div>
      <div class="row px-4 not-in-print">
        <form
          autocomplete="chrome-off"
          @submit.prevent="doFilter"
          class="col-12 row"
        >
          <div class="col-4">
            <DatePickerRange
              :fromFormatType="'YYYY-MM-DD'"
              :toFormatType="'YYYY-MM-DD'"
              :fromType="'date'"
              :toType="'date'"
              :dfFType="'jYYYY-jMM-jDD'"
              :dfTType="'jYYYY-jMM-jDD'"
              v-model="filter.date"
            />
          </div>
        <CustomerSearch
          :showLabel="false"
          class="col-md-4"
          :disabled="disabled"
          v-model="filterSelectedCustomer"
        />
        <b-form-group class="col-4">
          <multiselect
              placeholder="انتخاب انبار"
              v-model="selectedStore"
              open-direction="bottom"
              :options="stores"
              label="label"
              track-by="id"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              :disabled="disabled"
          >
              <template slot="noOptions"> موردی یافت نشد </template>
              <template slot="noResult"> موردی یافت نشد </template>
          </multiselect>
        </b-form-group>
          <div class="col-6 mt-1 d-flex">
            <button :disabled="disabled" type="submit" class="btn btn-primary">
              فیلتر
            </button>
          </div>
        </form> 
      </div>
      <div id="print-box" class="p-4">
        <div class="print-only">
          <h4>فروشگاه پاشیک</h4>
        </div>
        <br>
        <div
            class="d-flex mb-3 mr-2-print"
        >
          <span class="print-only ml-1 font-bold">گزارش مشتریان</span>
          <div v-if="appliedFilter.date.startDate">
              <span>از</span>
              <span class="font-weight-bold mx-1">تاریخ</span
                  ><span> {{ appliedFilter.date.startDate | persianDate }}</span>
              </div>
          <div class="mr-3"  v-if="appliedFilter.date.endDate">
              <span>تا</span>
              <span class="font-weight-bold mx-1">تاریخ</span
              ><span> {{ appliedFilter.date.endDate | persianDate }} </span>
          </div>
        </div>
        <b-table  
          :total-rows="totalRows"  
          :per-page="perPage"  
          :current-page="currentPage"  
          id="main-table" 
          data-mdb-fixed-header="true" 
          v-if="reports"  
          bordered  
          striped  
          :fields="fields"  
          :items="reports.data"  
          :filter="filter.search"  
          :sort-by.sync="sortBy"  
          :sort-desc.sync="sortDesc"  
          responsive="sm"  
        >  
          <template v-slot:cell(index)="data">  
            {{ data.index + 1 + (currentPage - 1) * perPage }}  
          </template>  
          <template v-slot:cell(sum_sold_amount)="data">  
            <span>{{ data.item.sum_sold_amount | price  }}</span>  
          </template>  
          <template v-slot:cell(customer_name)="data">  
            <span>{{ data.item.customer_name}}</span>  
          </template>  
          <template v-slot:cell(customer_mobile)="data">  
            <span>{{ data.item.customer_mobile}}</span>  
          </template>  
          <template #bottom-row="data">  
            <b-td colspan="2">جمع کل:</b-td>  
            <b-td>{{ totals.orders_count }}</b-td>  
            <b-td>{{ totals.sum_sold_items }}</b-td>  
            <b-td>{{ totals.sum_sold_amount | price  }}</b-td>  
          </template>  
        </b-table>  
          <Loading v-if="$root.isEmptyObject(reports)" />
           <pagination
            :router="true"
            v-else-if="reports && reports.data != ''"
            :disabled="disabled"
            :limit="2"
            :data="reports"
            @pagination-change-page="changePage"
          />
          <div v-else class="alert alert-danger">
            موردی یافت نشد
          </div>
      </div>
      <div class="d-flex flex-column w-100"></div>
    </div>
  </main>
</template>

<script>
import { BTable, BFormGroup, BFormInput, BTd, BPagination } from "bootstrap-vue";
import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
import ExcelDownload from "@@/core/components/excelDownload/ExcelDownload";
import CustomerSearch from "@@/core/components/shared/CustomerSearch/CustomerSearch";
import Loading from '@@/core/components/shared/Loading/Loading'

function Filter() {
  this.search = "";
  this.date = {
    startDate: "",
    endDate: "",
  };
}

Filter.prototype.set = function(filters) {
  Object.entries(filters).forEach(([index, value]) => {
    this[index] = value;
  });
};

export default {
  name: "SalesNew",
  components: {
      DatePickerRange,
      BTable,
      Loading,
      ExcelDownload,
      BFormGroup,
      BTd,
      BFormInput,
      CustomerSearch,
      BPagination,
  },
  data() {
      return {
          disabled: false,
          fields: [
              {
                  key: "index",
                  label: "ردیف",
              },,
              {
                  key: "customer_name",
                  label: "نام مشتری",
              },
              {
                  key: "customer_mobile",
                  label: "شماره مشتری",
              },
              {
                  key: "customer_scores",
                  label: "امتیاز کاربر",
              },
              {
                  key: "orders_count",
                  label: "تعداد سفارش",
              },
              {
                  key: "sum_sold_items",
                  label: "تعداد ایتم",
              },
              {
                  key: "sum_sold_amount",
                  label: "مجموع خرید ها(تومان)",
              },
          ],
          page: 1,
          perPage: 50,
          reports: null,
          sortBy: null,
          totals: null,
          selectedStore: null,
          stores: [],
          sortDesc: null,
            filterSelectedCustomer: "",
          filter: new Filter(),
          appliedFilter: new Filter(),
          currentPage: 1,
      };
  },
  created() {
      this.loadStores();
      this.loadData();
  },
  computed: {
    excelUrl() {
      const params = {
        start_date: this.appliedFilter.date.startDate,  
        end_date: this.appliedFilter.date.endDate,  
        store_id: this.selectedStore ? this.selectedStore.id : '',
        customer_id: this.filterSelectedCustomer
            ? this.filterSelectedCustomer.id
            : "", 
      };

      const queryString = Object.entries(params)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&');

      return `admin/reports/sales-new?${queryString}`;
    },
    extraQuery() {
        return {
            start_date: this.filter.date.startDate,
            end_date: this.filter.date.endDate,
        };
    },
    totalRows() {
        return this.reports ? this.reports.length : 0;
    },
  },
    watch: {
    per_page() {
      this.changePage(1)
    }
  },
  methods: {
    async loadStores(){
      try {
          const response = await this.$axios.get("admin/stores");
          this.stores = response.data.data.stores;
          this.disabled = false;
      } catch (e) {
          this.$root.notify(e);
      } 
    },
    changePage(page = 1) {
      this.previousPage = this.page;
      this.page = page;
      this.loadData()
    },
      print() {
        window.print();  
      },
      doFilter() {
          this.loadData();
      },
      async loadData() {
        try {
            let page = this.$route.query.page || 1;
            this.disabled = true;
            this.appliedFilter.set(this.filter);
            console.log(this.appliedFilter,'this.appliedFilter');
            
            const response = await this.$axios.get("admin/reports/sales-new", {  
                params: {  
                    page: page,
                    per_page: this.per_page,
                    start_date: this.appliedFilter.date.startDate,  
                    end_date: this.appliedFilter.date.endDate,  
                    store_id: this.selectedStore ? this.selectedStore.id : '',
                    customer_id: this.filterSelectedCustomer
                        ? this.filterSelectedCustomer.id
                        : "", 
                },  
            });  
            this.totals = response.data.data.totals;  
            // this.reports = Object.values(response.data.data.reports);
            this.reports = response.data.data.reports;
            console.log(typeof this.reports.data,'typeof reports');
        } catch (e) {
        this.$root.notify(e);
        } finally {
        this.disabled = false;
        }
      },
    },
  };
</script>
<style scoped>
</style>

<style>
.print-only {
display: none;
}
@media print {
.not-in-print {
  display: none !important;
}
#page-refund table tbody tr td:last-child{
  display: none;
}
#page-refund table thead tr th:last-child{
  display: none;
}
.app-content .side-app {
  padding: 0 !important;
}

.print-only {
  display: flex;
  justify-content: center; 
}

body * {
  text-align: center !important;
  background-color: transparent;
  visibility: hidden;
}
#print-box,
#print-box * {
  visibility: visible;
  font-size: 1.25rem;
}
#print-box {
  padding: 0 !important;
}
#print-box {
  width: 100%;
}

#print-box .not-in-print {
  display: none;
}

.mr-2-print {
  margin-right: 20px;
}
}
</style>